import { initRouter, route, render, navigate } from './router.js';
import { store } from './store.js';
import { api } from './api.js';
import { renderLoginPage } from './pages/login.js';
import { renderRegisterPage } from './pages/register.js';
import { renderOnboardingPage } from './pages/onboarding.js';
import { renderDashboardPage } from './pages/dashboard.js';
import { renderTrainerPage } from './pages/trainer.js';
import { renderForgotPasswordPage } from './pages/forgotPassword.js';
import { renderResetPasswordPage } from './pages/resetPassword.js';
import { renderVerifyEmailPage } from './pages/verifyEmail.js';
import { renderAdminUsersPage } from './pages/adminUsers.js';
import { renderSupportPage } from './pages/support.js';
import { renderAdminTicketsPage } from './pages/adminTickets.js';
import { renderAdminSettingsPage } from './pages/adminSettings.js';

const PUBLIC_PATHS = new Set(['/login', '/register', '/forgot-password', '/reset-password', '/verify-email']);

async function bootstrap() {
  const appRoot = document.getElementById('app');
  initRouter(appRoot);

  route('/login', renderLoginPage);
  route('/register', renderRegisterPage);
  route('/forgot-password', renderForgotPasswordPage);
  route('/reset-password', renderResetPasswordPage);
  route('/verify-email', renderVerifyEmailPage);
  route('/onboarding', guarded(renderOnboardingPage));
  route('/', guarded(renderDashboardPage));
  route('/trainer', guarded(renderTrainerPage));
  route('/admin/users', guarded(renderAdminUsersPage));
  route('/admin/tickets', guarded(renderAdminTicketsPage));
  route('/admin/settings', guarded(renderAdminSettingsPage));
  route('/support', guarded(renderSupportPage));

  try {
    const { user } = await api.auth.me();
    store.user = user;
  } catch {
    store.user = null;
  }

  const path = location.pathname;

  // Unauthenticated users → landing at /. Other protected paths → /login.
  if (!store.user) {
    if (path === '/') {
      window.location.replace('/landing.html');
      return;
    }
    if (!PUBLIC_PATHS.has(path)) {
      history.replaceState(null, '', '/login');
      await render('/login');
      return;
    }
  } else if (PUBLIC_PATHS.has(path)) {
    history.replaceState(null, '', '/');
    await render('/');
    return;
  }
  await render(path);
}

function guarded(fn) {
  return async (ctx) => {
    if (!store.user) {
      navigate('/login', { replace: true });
      return;
    }
    return fn(ctx);
  };
}

bootstrap();
